import { Button } from "antd";
import React from "react";

import useActionHandler, { MODAL_KEYS } from "@hooks/useActionHandler";
import { i18, trb } from "@utilities";

import { AdditionalDocsModal } from "./Modals/AdditionalDocsModal";
import { AddRiskModal } from "./Modals/AddRiskModal";
import { ApproveBeneficiaresModal } from "./Modals/ApproveBeneficiaresModal";
import { ApproveRisksModal } from "./Modals/ApproveRisksModal";
import { RejectDueSanctionsModal } from "./Modals/RejectDueSanctionsModal";
import { RejectModal } from "./Modals/RejectModal";
import { RejectUploadAgreement } from "./Modals/RejectUploadAgreement";
import { ConfirmUploadAgreement } from "./Modals/ConfirmUploadAgreement";

import "./AvailableAppActions.less";

export const AvailableAppActions = React.memo(() => {
  const [currentAppActions, isModalOpen, handleAction, toggleActionModal] = useActionHandler();

  if (!currentAppActions.length) return null;

  return (
    <>
      <div className="kyc-application-action-container my-4 d-flex">
        {currentAppActions.map(actionInfo => (
          <Button
            key={actionInfo.name}
            onClick={() => handleAction(actionInfo.name)}
            type="primary"
            size="middle"
          >
            {trb(i18.ApplicationsActions[actionInfo.name]) || actionInfo.name}
          </Button>
        ))}
      </div>
      {isModalOpen[MODAL_KEYS.ADDITIONAL_DOCS] && (
        <AdditionalDocsModal onClose={() => toggleActionModal(MODAL_KEYS.ADDITIONAL_DOCS)} />
      )}
      {isModalOpen[MODAL_KEYS.APPROVE_BENEFICIARES] && (
        <ApproveBeneficiaresModal
          onClose={() => toggleActionModal(MODAL_KEYS.APPROVE_BENEFICIARES)}
        />
      )}
      {isModalOpen[MODAL_KEYS.REJECT_APP] && (
        <RejectModal onClose={() => toggleActionModal(MODAL_KEYS.REJECT_APP)} />
      )}
      {isModalOpen[MODAL_KEYS.REJECT_DUE_SANCTIONS] && (
        <RejectDueSanctionsModal
          onClose={() => toggleActionModal(MODAL_KEYS.REJECT_DUE_SANCTIONS)}
        />
      )}
      {isModalOpen[MODAL_KEYS.ADD_RISK] && (
        <AddRiskModal onClose={() => toggleActionModal(MODAL_KEYS.ADD_RISK)} />
      )}
      {isModalOpen[MODAL_KEYS.RISK_APPROVE] && (
        <ApproveRisksModal onClose={() => toggleActionModal(MODAL_KEYS.RISK_APPROVE)} />
      )}
      {isModalOpen[MODAL_KEYS.REJECT_UPLOAD_AGREEMENT] && (
        <RejectUploadAgreement
          onClose={() => toggleActionModal(MODAL_KEYS.REJECT_UPLOAD_AGREEMENT)}
        />
      )}
      {isModalOpen[MODAL_KEYS.APPROVE_UPLOAD_AGREEMENT] && (
        <ConfirmUploadAgreement
          onClose={() => toggleActionModal(MODAL_KEYS.APPROVE_UPLOAD_AGREEMENT)}
        />
      )}
    </>
  );
});
